import ChipRow from "./chip-row";

// Shares the `.mood` slide-up sheet styling; Mood was just its first user.
export default function FeedbackSheet({
  open,
  isFeedbackEnabled,
  isRateAppEnabled,
  onFeedbackClick,
  onFaqClick,
  onRateAppClick,
  onAboutClick,
}) {
  const feedbackEnabled = isFeedbackEnabled !== false;
  const items = [
    {
      key: "feedback",
      label: "Share Feedback",
      title: "Share general feedback",
      onClick: () => onFeedbackClick?.("general"),
      enabled: feedbackEnabled,
    },
    {
      key: "bug",
      label: "Bug Report",
      title: "Tell us what is not working",
      onClick: () => onFeedbackClick?.("bug"),
      enabled: feedbackEnabled,
    },
    {
      key: "feature",
      label: "Feature Request",
      title: "Suggest something new",
      onClick: () => onFeedbackClick?.("feature"),
      enabled: feedbackEnabled,
    },
    {
      key: "faq",
      label: "FAQ",
      title: "Open frequently asked questions",
      onClick: onFaqClick,
      enabled: true,
    },
    {
      key: "rate",
      label: "Rate App",
      title: "Leave a review on the Chrome Web Store",
      onClick: onRateAppClick,
      enabled: isRateAppEnabled !== false,
    },
    {
      key: "about",
      label: "About",
      title: "Read about Slowed",
      onClick: onAboutClick,
      enabled: true,
    },
  ].filter((item) => item.enabled);

  return (
    <div
      id="mood-sheet"
      className={`mood mood--feedback${open ? " mood--open" : ""}`}
      aria-label="Feedback"
      aria-hidden={!open}
      {...(!open ? { inert: true } : {})}
    >
      <div className="mood__header">
        <div className="content__title">Feedback</div>
        <p className="mood__subtitle">Get help, share feedback, or rate Slowed.</p>
      </div>

      <ChipRow>
        {items.map((item) => (
          <button
            key={item.key}
            type="button"
            className="mood__chip"
            onClick={item.onClick}
            title={item.title}
            tabIndex={open ? 0 : -1}
          >
            <span className="mood__chip-name">{item.label}</span>
          </button>
        ))}
      </ChipRow>
    </div>
  );
}
